import React from 'react';

import { injectIntl } from 'react-intl';
import { useOwner } from '../context/context.js';

import OwnerMenu from '../ui_items/OwnerMenu.js';

const BuzzMainMenu = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false || parseInt(promotion.promo_type) < 1) return null;
	
	const public_entries = (promotion.public_entries == '1') ? true : false;
	const selected = props?.selected ?? false;

	let _s = {};

	/*_s.general = {
		title:"General",
		items:[{
			url:`/promotions/profile/${promotion.id}`,
			icon:'knk-home',
			selected:(selected == 'profile') ? true : false,
			children:"Home",
		}],
	}*/

	_s.buzz = {
		title:"Publication resources",
		items:[{
			enabled:true,
			url:`/buzz/widget/${promotion.id}`,
			icon:'knk-embed',
			selected:(selected == 'widget') ? true : false,
			children:"Widget",
		}, {
			enabled:true,
			url:`/buzz/twitch_campaign/${promotion.id}`,
			icon:'ep-twitch',
			selected:(selected == 'twitch_campaign') ? true : false,
			children:"Twitch Campaign",
		}, {
			enabled:(public_entries) ? true : false,
			url:`/buzz/twitch_leaderboard/${promotion.id}`,
			icon:'ep-twitch',
			selected:(selected == 'twitch_leaderboard') ? true : false,
			children:"Twitch Leaderboard",
		}],
	}

	return (
		<OwnerMenu sections={Object.values(_s)} />
	)
}

export default injectIntl(BuzzMainMenu);